import { useEffect, useState } from "react";
import Button from "../../components/Button";
import NFTCard from "../../components/NFTCard";
import { NFT_ADDR, USDT_ADDR } from "../../config/contracts";
import useNftInfo from "../../hooks/useNftInfo";
import { useAddress, useWeb3Context } from "../../hooks/web3Context";
import { ETHSVG } from "../../utils/svgs";
import useProjectInfo from "../../hooks/useProjectinfo";
import { figureError } from "../../utils/functions";
import { getErc20TokenContract, getNFTContract } from "../../utils/contracts";
import { ethers } from "ethers";
import ConnectButton from "../../components/ConnectButton";

function CollectionDescription() {
  const { nftInfo, fetchNftData, fetchAccountNftData, accountNftInfo } = useNftInfo();
  const { pending, setPending, setNotification } = useProjectInfo();
  const { chainID, provider } = useWeb3Context();
  const account = useAddress();
  const [quantity, setQuantity] = useState(1);
  const [showNFTId, setShowNFTId] = useState(1);

  useEffect(() => {
    setInterval(() => {
      setShowNFTId(Math.floor(Math.random() * 1100 + 1));
    }, 30000);
  }, []);

  async function onApprove() {
    setPending(true);
    try {
      const tokenContract = getErc20TokenContract(
        USDT_ADDR[chainID],
        provider.getSigner(),
        chainID
      );
      const estimateGas = await tokenContract.estimateGas.approve(
        NFT_ADDR[chainID],
        ethers.constants.MaxUint256
      );
      const tx = {
        gasLimit: estimateGas.toString(),
      };
      const approvetx = await tokenContract.approve(
        NFT_ADDR[chainID],
        ethers.constants.MaxUint256,
        tx
      );
      await approvetx.wait();
      fetchAccountNftData();
    } catch (error) {
      console.log(error);
      figureError(error, setNotification);
    }
    setPending(false);
  }

  async function onMint() {
    setPending(true);
    try {
      const nftContract = getNFTContract(provider.getSigner(), chainID);
      const gasLimit = await nftContract.estimateGas.mint(quantity);

      const tx = await nftContract.mint(quantity, {
        gasLimit: gasLimit.mul(12).div(10),
      });
      await tx.wait(2);

      fetchNftData();
      fetchAccountNftData();
      // setTimeout(fetchAccountNftData, 10000);
      setQuantity(0);
    } catch (e) {
      console.log(e);
      figureError(e, setNotification);
    }
    setPending(false);
  }

  return (
    <div className="w-full px-3 text-primary">
      <div className="w-full max-w-[1362px] mx-auto mt-[97px] mb-[90px] flex justify-between items-center xl:flex-row flex-col-reverse">
        <div className="flex-1 xl:mr-20 mr-0 max-w-[834px] xl:mt-0 mt-8 w-full">
          <div className="lg:text-2xl text-lg font-semibold text-green">Collection Description</div>
          <div className="lg:sm:text-xl sm:text-base text-sm mt-3">
            TrueApex is a collection that contains 1100 carefully selected NFTs, each representing a
            symbolic gateway to the world of wealth and prosperity. The TrueApex NFT collection is
            the entry to TrueApex Finance, a Revolutionary defi platform aimed at providing
            financial success and financial independence. TrueApex is a one stop bank with a profit
            sharing model. Experience the fusion of innovation and creative expression as you embark
            on a transformative journey toward your personal apex of success. Have unlimited access
            to wealth through profit sharing!
          </div>
          <div className="flex lg:mt-[70px] mt-8">
            <div className="bg-[#F7F7F7] rounded-[30px] flex-1 lg:sm:p-[16px_10px_24px_24px] sm:p-[12px_10px_12px_24px] p-[12px_16px]">
              <div className="lg:sm:text-base sm:text-sm text-xs">Collection name</div>
              <div className="lg:sm:text-[48px] sm:text-[36px] text-2xl lg:sm:leading-none sm:leading-[1.2] leading-[1.4]">
                @{nftInfo.name}
              </div>
            </div>
            <div className="bg-[#F7F7F7] rounded-[30px] flex-1 lg:sm:p-[16px_10px_24px_24px] sm:p-[12px_10px_12px_24px] p-[12px_16px] ml-2">
              <div className="lg:sm:text-base sm:text-sm text-xs">Total NFTs Available</div>
              <div className="lg:sm:text-[48px] sm:text-[36px] text-2xl lg:sm:leading-none sm:leading-[1.2] leading-[1.4]">
                {nftInfo.totalSupply}/{nftInfo.maxSupply}
              </div>
            </div>
          </div>
          <div className="bg-[#F7F7F7] rounded-[30px] lg:sm:p-[16px_10px_24px_24px] sm:p-[12px_10px_12px_24px] p-[12px_16px] w-full mt-10">
            <div className="lg:sm:text-base sm:text-sm text-xs">Current Address</div>
            <div className="lg:sm:text-2xl sm:text-lg text-base mt-2 text-ellipsis overflow-hidden">
              {NFT_ADDR[chainID]}
            </div>
          </div>

          <div className="bg-[#F7F7F7] rounded-[30px] lg:sm:p-[16px_24px] sm:p-[12px_24px] p-[12px_16px] w-full mt-10 flex justify-between items-center">
            <div>
              <div className="lg:sm:text-base sm:text-sm text-xs">Quantity</div>
              <div className="lg:sm:text-[48px] sm:text-[36px] text-2xl lg:sm:leading-none sm:leading-[1.2] leading-[1.4] flex items-center">
                <div className="mr-3">
                  <img
                    src={"/images/usdt.svg"}
                    alt={""}
                    className="lg:w-10 w-6 lg:h-10 h-6 rounded-full"
                  />
                </div>
                <div>
                  {(nftInfo.mintPrice / Math.pow(10, 6)).toFixed(2)}{" "}
                  <span className="lg:sm:text-[40px] sm:text-[32px] text-xl xs:contents hidden">
                    USDT
                  </span>
                </div>
              </div>
            </div>
            <div className="lg:sm:w-[289px] sm:w-[200px] w-[130px] lg:sm:h-[85px] sm:h-[60px] h-[50px] rounded-[20px] bg-white flex justify-between items-center sm:p-[10px_14px] p-1.5">
              <button
                className="lg:text-[40px] text-[28px] font-[800] flex justify-center items-center lg:sm:w-[68px] sm:w-[48px] w-[36px] lg:sm:h-[64px] sm:h-[48px] h-[36px] rounded-full bg-primary cursor-pointer text-white transition-all enabled:hover:opacity-80 disabled:bg-[#E5E5E5] disabled:cursor-not-allowed"
                disabled={quantity <= 1}
                onClick={() => setQuantity(quantity - 1)}
              >
                -
              </button>
              <div className="text-green lg:sm:text-[40px] sm:text-[28px] text-xl">{quantity}</div>
              <button
                className="lg:text-[40px] text-[28px] font-[800] flex justify-center items-center lg:sm:w-[68px] sm:w-[48px] w-[36px] lg:sm:h-[64px] sm:h-[48px] h-[36px] rounded-full bg-primary cursor-pointer text-white transition-all enabled:hover:opacity-80 disabled:bg-[#E5E5E5] disabled:cursor-not-allowed"
                disabled={quantity >= nftInfo.maxSupply - nftInfo.totalSupply || quantity >= 10}
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>

          <div className="bg-[#F7F7F7] rounded-[30px] sm:p-6 p-[12px_16px] w-full mt-10 flex justify-between items-end">
            <div>
              <div className="lg:sm:text-base sm:text-sm text-xs">Total Price</div>
              <div className="lg:sm:text-[48px] sm:text-[36px] text-2xl lg:sm:leading-none sm:leading-[1.2] leading-[1.4] flex items-center">
                <div className="mr-3">
                  <img
                    src={"/images/usdt.svg"}
                    alt={""}
                    className="lg:w-10 w-6 lg:h-10 h-6 rounded-full"
                  />
                </div>
                <div>
                  {((quantity * nftInfo.mintPrice) / Math.pow(10, 6)).toFixed(2)}{" "}
                  <span className="lg:sm:text-[40px] sm:text-[32px] text-xl xs:contents hidden">
                    USDT
                  </span>
                </div>
              </div>
            </div>
            <div className="sm:text-base text-sm text-green">
              ~${((quantity * nftInfo.mintPrice) / Math.pow(10, 6)).toFixed(2)}
            </div>
          </div>

          <div className="mt-12">
            {account ? (
              accountNftInfo.allowance ? (
                <Button
                  className="w-full rounded-[30px] bg-primary text-white text-[15px] font-bold h-[55px] transition-all hover:opacity-80"
                  type={"default"}
                  disabled={!quantity || pending || !nftInfo.mintAllowed}
                  onClick={() => onMint()}
                >
                  {nftInfo.mintAllowed ? "MINT NOW" : "MINT NOT ENABLED"}
                </Button>
              ) : (
                <Button
                  className="w-full rounded-[30px] bg-primary text-white text-[15px] font-bold h-[55px] transition-all hover:opacity-80"
                  type={"default"}
                  disabled={pending}
                  onClick={() => onApprove()}
                >
                  APPROVE USDT
                </Button>
              )
            ) : (
              <ConnectButton fullWidth={true} />
            )}
          </div>
        </div>
        <NFTCard
          tokenId={showNFTId}
          price={nftInfo.mintPrice / Math.pow(10, 6)}
          size={"450px"}
          type={"info"}
          logo={`https://maverickbl.mypinata.cloud/ipfs/QmWv2LJVeEQcf4MPaA6azNSs3TvY3NifeXq6VkDRF4bZ2m/${showNFTId}.png`}
        />
      </div>
    </div>
  );
}

export default CollectionDescription;
